<template>
    <div v-if="tooltip" class="ui-icon-wrapper">
        <span
            :class="iconClasses"
            :style="iconStyles"
        ></span>
        <div class="ui-icon-tooltip">
            {{ tooltip }}
        </div>
    </div>
    <span
        v-else
        :class="iconClasses"
        :style="iconStyles"
    ></span>
</template>

<script>
export default {
    name: "Icon",
    props: {
        color: {
            type: String,
            default: "currentColor",
            validator: function (value) {
                return typeof value === "string";
            }
        },
        size: {
            type: [String, Number],
            default: 3,
            validator: function (value) {
                if (typeof value === "number") {
                    return value >= 1 && value <= 20;
                }
                if (typeof value === "string") {
                    const num = parseInt(value);
                    return !isNaN(num) && num >= 1 && num <= 20;
                }
                return false;
            }
        },
        iconClass: {
            type: String,
            required: true,
            validator: function (value) {
                return typeof value === "string" && value.length > 0;
            }
        },
        tooltip: {
            type: String,
            default: null,
            validator: function (value) {
                return value === null || typeof value === "string";
            }
        }
    },
    computed: {
        iconClasses() {
            return [
                "ui-icon",
                this.iconClass,
                this.sizeClass
            ];
        },
        sizeClass() {
            const sizeNum = typeof this.size === "string" ? parseInt(this.size) : this.size;
            return `ui-icon--size-${sizeNum}`;
        },
        iconStyles() {
            return {
                color: this.color.startsWith("#") ? this.color : `var(--${this.color})`,
            };
        }
    }
};
</script>

<style lang="less" scoped>
.ui-icon-wrapper {
    position: relative;
    display: inline-block;
    background: none;

    &:hover .ui-icon-tooltip {
        opacity: 1;
        visibility: visible;
        transform: translateX(-50%) translateY(-25%);
    }
}

.ui-icon-tooltip {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%) translateY(-105%);
    background-color: black;
    color: white;
    border-radius: 8px;
    padding: 6px 8px;
    font-size: 12px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease;
    z-index: 1000;
    pointer-events: none;

    &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid black;
    }

    &::before {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid black;
        z-index: -1;
    }
}

.ui-icon {
    display: inline-block;
    flex-shrink: 0;
    transition: color 0.2s ease;

    &--size-1 {
        width: 12px;
        height: 12px;
    }

    &--size-2 {
        width: 14px;
        height: 14px;
    }

    &--size-3 {
        width: 16px;
        height: 16px;
    }

    &--size-4 {
        width: 18px;
        height: 18px;
    }

    &--size-5 {
        width: 20px;
        height: 20px;
    }

    &--size-6 {
        width: 22px;
        height: 22px;
    }

    &--size-7 {
        width: 24px;
        height: 24px;
    }

    &--size-8 {
        width: 26px;
        height: 26px;
    }

    &--size-9 {
        width: 28px;
        height: 28px;
    }

    &--size-10 {
        width: 30px;
        height: 30px;
    }

    &--size-11 {
        width: 32px;
        height: 32px;
    }

    &--size-12 {
        width: 34px;
        height: 34px;
    }

    &--size-13 {
        width: 36px;
        height: 36px;
    }

    &--size-14 {
        width: 38px;
        height: 38px;
    }

    &--size-15 {
        width: 40px;
        height: 40px;
    }

    &--size-16 {
        width: 42px;
        height: 42px;
    }

    &--size-17 {
        width: 44px;
        height: 44px;
    }

    &--size-18 {
        width: 46px;
        height: 46px;
    }

    &--size-19 {
        width: 48px;
        height: 48px;
    }

    &--size-20 {
        width: 50px;
        height: 50px;
    }
}
</style>
